import React from 'react'
import PropTypes from 'prop-types'

import { isNumberOnly } from 'utils/validations'

import Constants from 'Constants'
import T from 'T'
import { Box, Dialog, DialogContent, Stack, Typography } from '@mui/material'
import HHDialogActions from 'components/common/HHDialogActions'
import CancelButton from 'components/buttons/CancelButton'
import SaveButton from 'components/buttons/SaveButton'
import HHTextField from 'components/form-fields/v5/HHTextField'

const { MEDIA_SERVER } = Constants

const CVVConfirmation = ({ cvv, confirmationModalOpen, closeCVVModal, onCVVChange, handleMakePayment, isProceedLoading = false }) => {
  return (
    <>
      <Dialog open={confirmationModalOpen} onClose={closeCVVModal} disableBackdropClick disableEscapeKeyDown>
        <DialogContent>
          <Typography variant="h6" fontWeight={500} className="mb-2">
            {T.CVV_TITLE}
          </Typography>
          <HHTextField
            onChange={event => {
              if (event.target.value === '' || isNumberOnly(event.target.value)) {
                onCVVChange(event.target.value)
              }
            }}
            fullWidth
            sx={{ mt: 2 }}
            deprecatedLabel={false}
            label={T.CARD_CVV}
            name="cvv"
            type="password"
            placeholder="123"
            value={cvv}
          />
          <Stack alignItems="center" justifyContent="center" direction="row" sx={{ mt: 2 }}>
            <Box component="img" src={`${MEDIA_SERVER}CVV.svg`} alt="" />
          </Stack>
        </DialogContent>
        <HHDialogActions>
          <CancelButton onClick={closeCVVModal} />
          <SaveButton
            label={T.APPLY}
            onClick={() => {
              handleMakePayment()
              closeCVVModal()
            }}
            disabled={cvv === '' || isProceedLoading}
          />
        </HHDialogActions>
      </Dialog>
    </>
  )
}

CVVConfirmation.defaultProps = {
  cvv: '',
  confirmationModalOpen: '',
  closeCVVModal: null,
  onCVVChange: null,
  handleMakePayment: null,
}

CVVConfirmation.propTypes = {
  cvv: PropTypes.string,
  confirmationModalOpen: PropTypes.string,
  closeCVVModal: PropTypes.func,
  onCVVChange: PropTypes.func,
  handleMakePayment: PropTypes.func,
  isProceedLoading: PropTypes.bool,
}

export default CVVConfirmation
